/**
 * TanStack Query hooks for `gdpr-dsr`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	gdprDsrQueryKeys,
	type CreateGdprDsrBody,
	type ListGdprDsrResponse,
	type GdprDsrRow,
} from "./api";

export function useGdprDsrList(): UseQueryResult<ListGdprDsrResponse, Error> {
	return useQuery({
		queryKey: gdprDsrQueryKeys.list(),
		queryFn: list,
	});
}

export function useGdprDsrCreate(): UseMutationResult<GdprDsrRow, Error, CreateGdprDsrBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gdprDsrQueryKeys.all });
		},
	});
}

export function useGdprDsrDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gdprDsrQueryKeys.all });
		},
	});
}
